// One step up or down the reseller's own list: two icon buttons per row, the one past an end
// disabled. Buttons rather than drag and drop, so the order is reachable from the keyboard and
// needs no styling.
import { ArrowDown, ArrowUp } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { m } from "@/lib/paraglide/messages.js";
import { pricingError } from "../pricing-error";
import { useMoveTld } from "./mutation";

type Props = { tldId: string; tld: string; first: boolean; last: boolean };

export function MoveTldButtons({ tldId, tld, first, last }: Props) {
  const move = useMoveTld(tldId);
  const name = `.${tld}`;
  const step = (direction: "up" | "down") =>
    move.mutate(direction, { onError: (error) => toast.error(pricingError(error)) });
  return (
    <>
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label={m.tld_pricing_move_up({ tld: name })}
        disabled={first || move.isPending}
        onClick={() => step("up")}
      >
        <ArrowUp />
      </Button>
      <Button
        variant="ghost"
        size="icon-sm"
        aria-label={m.tld_pricing_move_down({ tld: name })}
        disabled={last || move.isPending}
        onClick={() => step("down")}
      >
        <ArrowDown />
      </Button>
    </>
  );
}
